import React, { useEffect, useState } from 'react';
import { FaCogs, FaInfoCircle } from 'react-icons/fa';
import Table from './components/Table/Table';
import GuideModal from './components/GuideModal/GuideModal';
import { GetAllModifiersByLocalId } from '../../../../crud/menu_api/selection_modifiers';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import './SelectionModifiers.scss';

interface SelectionModifierType {
  readonly modifier_id: number;
  modifier_name: string;
  modifier_description?: string;
  local_id: number;
  items_affected: Array<{
    item_id: number;
    item_name: string;
  }>;
  options_included: Array<{
    option_id: number;
    option_name: string;
  }>;
}

const SelectionModifiers: React.FC = () => {
  const [selectionModifiers, setSelectionModifiers] = useState<SelectionModifierType[]>([]);
  const [loading, setLoading] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const local_id = user ? user.local_id : 0;

    GetAllModifiersByLocalId(local_id)
      .then((response) => {
        setSelectionModifiers(response.data);
      })
      .catch((error) => {
        console.error('Error fetching selection modifiers', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderHeader = () => (
    <div className="selection-modifiers-header">
      <div className="header-content">
        <div className="title-section">
          <FaCogs className="title-icon" />
          <div className="title-text">
            <h1>Grupos Modificadores</h1>
            <p>Crea grupos de opciones para personalizar características de tus productos</p>
          </div>
        </div>

        <div className="header-actions">
          <button 
            className="info-button"
            onClick={() => setShowHelpModal(true)}
          >
            <FaInfoCircle />
            <span>¿Cómo funciona?</span>
          </button>
        </div>
      </div>

      {/* Información explicativa */}
      <div className="explanation-banner">
        <div className="banner-content">
          <div className="banner-text">
            <h3>¿Qué son los Grupos Modificadores?</h3>
            <p>
              Los Grupos Modificadores te permiten crear opciones que cambian características de tus productos sin afectar el inventario. 
              Por ejemplo: tamaños (chico, mediano, grande), temperatura (frío, caliente), 
              o nivel de cocción (término medio, bien cocido).
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return <LoadingSpinner text="Cargando tus grupos modificadores..." transparent={true} />;
  }

  return (
    <div className="selection-modifiers-container">
      {renderHeader()}
      <Table data={selectionModifiers} setData={setSelectionModifiers} />
      <GuideModal show={showHelpModal} onClose={() => setShowHelpModal(false)} />
    </div>
  );
};

export default SelectionModifiers;